// === SAA:UI:ADVISOR-PHOTO ===
// Full-bleed advisor photo at the top of the advisor ("Hulp nodig?") card. the
// trust card has the same slot behind its showPhoto prop.
// Renders nothing without a configured url: never ship a placeholder image.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useConfig } from '@sluitstraat/core';
import { commonStyles } from '../styles/commonStyles';
import { getSidebarTexts, resolveSidebarText } from '../config/sidebarContent';

export const AdvisorPhoto: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { config } = useConfig();
  const sidebar = getSidebarTexts(config);
  if (!sidebar.advisorPhotoUrl) return null;

  return (
    <div style={commonStyles.advisorPhotoWrap}>
      <img
        src={sidebar.advisorPhotoUrl}
        alt={resolveSidebarText(t, i18n, sidebar.advisorPhotoAltKey, 'sidebar.advisor.photoAlt')}
        style={commonStyles.advisorPhoto}
      />
      <div style={commonStyles.advisorPhotoFade} aria-hidden="true" />
    </div>
  );
};

export default AdvisorPhoto;
